import gql from 'graphql-tag';

export default gql`
  mutation ZipLabelPacel($linkLabels: [String]) {
    zipLabelPacel(linkLabels: $linkLabels) {
      linkDownLoad
    }
  }
`;
